<template>
  <div class="pt-5" :class="{ '-grid': grid }">
    <div class="flex gap-2 justify-end">
      <slot name="more" />

      <Link v-if="showCancel"
            :href="cancelUrl"
            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        Cancel
      </Link>

      <button type="submit"
              :disabled="disabled"
              v-if="showSubmit"
              class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        {{ submitLabel }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.-grid {
  @apply col-span-6;
}
</style>
<style>
button[disabled] {
  @apply opacity-50;
}
</style>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },

  props: {
    cancelUrl: String,
    grid: Boolean,
    submitLabel: {
      type: String,
      default: 'Save',
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
  }
}
</script>
